module.exports = __webpack_public_path__ + "img/logotrend.00d7be7e.png";